import { ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

import type { SoftwareAssuranceWorkflowController } from '@/hooks/workflow/useSoftwareAssuranceWorkflow'

interface MissionStepSectionProps {
  workflow: SoftwareAssuranceWorkflowController
}

export function MissionStepSection({ workflow }: MissionStepSectionProps) {
  const navigate = useNavigate()

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h4 className="text-sm font-semibold">Mission Context</h4>
          <p className="text-xs text-muted-foreground">Select an existing mission or create a new one.</p>
        </div>
        <Button variant="outline" onClick={() => navigate('/missions?action=create')}>
          Create Mission
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
      {workflow.missionsLoading ? (
        <div className="flex items-center justify-center py-6">
          <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin" />
        </div>
      ) : (
        <div className="grid gap-2">
          {workflow.missions.map((mission) => (
            <button
              key={mission.mission_id}
              onClick={() => workflow.setSelectedMissionId(mission.mission_id)}
              className={cn(
                'w-full text-left p-3 rounded-lg border transition-colors',
                workflow.selectedMissionId === mission.mission_id
                  ? 'border-primary bg-primary/10'
                  : 'border-border hover:bg-muted/40'
              )}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-medium">{mission.mission_name}</p>
                  <p className="text-xs text-muted-foreground">{mission.mission_objective}</p>
                </div>
                <Badge variant="secondary">{mission.status}</Badge>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
